var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaprueba1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.54 25.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.52px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.18,5c-.76,0-1.44.61-1.44,1.44,0,.76.61,1.44,1.44,1.44.76,0,1.44-.61,1.44-1.44-.08-.76-.68-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.89,6.82c-3.26,0-5.91,2.65-5.91,5.91s2.65,5.91,5.91,5.91,5.91-2.65,5.91-5.91-2.65-5.91-5.91-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.59,24.79H7.96c-4.02,0-7.2-3.26-7.2-7.2V7.96C.76,3.94,4.02.76,7.96.76h9.63c4.02,0,7.2,3.26,7.2,7.2v9.63c0,3.94-3.18,7.2-7.2,7.2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaprueba1);
export default __webpack_public_path__ + "static/media/Instaprueba1.53aa0f40d9a1e366f0f973c30c3dabad.svg";
export { ForwardRef as ReactComponent };